import React from 'react';
import { useState } from 'react';
import { Row, Col, Button, Collapse, Card, CardBody } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

import { Link } from 'react-router-dom';
import displayDate from '../Helpers/displayDate';
import { TestMeasurement } from '../types';
import TestsPopover from '../components/TestsPopover';

interface ITestResult {
  measurements: TestMeasurement[];
  title: string;
  unit: string;
  removeTest: any;
}

export const TestResult: React.FC<ITestResult> = ({ measurements, title, unit, removeTest }) => {
  const { t } = useTranslator();
  const [collapse, setCollapse] = useState(measurements.length > 0 ? true : false);

  const {
    svgInline: { DownArrow },
  } = useAppContext();

  const toggle = () => {
    setCollapse(!collapse);
  };

  const renderArrow = () => {
    if (collapse) {
      return (
        <span className="collapse-arrow open">
          <span className="SVGInline">
            <DownArrow />
          </span>
        </span>
      );
    }

    return (
      <span className="collapse-arrow">
        <span className="SVGInline">
          <DownArrow />
        </span>
      </span>
    );
  };

  const getHistoryUrl = () => {
    switch (title) {
      case 'tsh':
        return '/lab-tests/history/tsh';
      case 'ft3':
        return '/lab-tests/history/ft3';
      case 'ft4':
        return '/lab-tests/history/ft4';
      case 'antiTpo':
        return '/lab-tests/history/antiTpo';
      case 'antiTg':
        return '/lab-tests/history/antiTg';
    }
  };

  return (
    <section className="cursor-pointer">
      <p className="medium mb-0">
        {t(`labTests.${title}`)}
        <Button color="link" className="py-0 px-0 float-end" onClick={toggle}>
          {renderArrow()}
        </Button>
      </p>

      <Collapse isOpen={collapse}>
        {measurements.length > 0 ? (
          <Card className="mt-3">
            <CardBody>
              {measurements.map((measurement, idx: number) => {
                if (idx < 4) {
                  return (
                    <div key={idx}>
                      <Row className="align-items-center">
                        <Col>
                          <p className="description mb-0">{displayDate(measurement.testedAt)}</p>
                        </Col>
                        <Col className="text-end">
                          <p className="mb-0">
                            <span className="title-large semi-bold">
                              {measurement.value && measurement.value.toString().replace('.', ',')}
                            </span>{' '}
                            <span className="description"> {unit}</span>
                            <TestsPopover
                              removeMeasurement={removeTest}
                              measurement={{ ...measurement, type: title }}
                            />
                          </p>
                        </Col>
                      </Row>
                      {idx < measurements.length - 1 && idx < 3 && <hr />}
                    </div>
                  );
                }
                return null;
              })}

              {measurements.length > 4 && (
                <div className="text-center">
                  <Button color="link" size="sm" tag={Link} className="mt-3" to={getHistoryUrl()}>
                    {t('labTests.seeMore.button')}
                  </Button>
                </div>
              )}
            </CardBody>
          </Card>
        ) : (
          <p className="description pt-3 mb-0">{t('labTests.noData.subtitle')}</p>
        )}
      </Collapse>
    </section>
  );
};

export default TestResult;
